"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _airbnbPropTypes = require("airbnb-prop-types");

var _propTypes = require("prop-types");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _option = require("./option");

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

var _deprecatedProp = _interopRequireDefault(require("../helpers/deprecated-prop"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SelectionGroup = function SelectionGroup(_ref) {
  var children = _ref.children,
      id = _ref.id,
      onChange = _ref.onChange,
      multiple = _ref.multiple,
      fluid = _ref.fluid,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? fluid : _ref$fullWidth,
      primary = _ref.primary,
      name = _ref.name,
      small = _ref.small,
      large = _ref.large,
      disabled = _ref.disabled,
      error = _ref.error,
      warning = _ref.warning,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === void 0 ? '0' : _ref$tabIndex,
      props = _objectWithoutProperties(_ref, ["children", "id", "onChange", "multiple", "fluid", "fullWidth", "primary", "name", "small", "large", "disabled", "error", "warning", "tabIndex"]);

  var classes = ['co-selection-group', {
    'co-selection-group--multiple': multiple
  }];
  var allowedModifiers = {
    primary: primary,
    small: small,
    large: large,
    error: error,
    warning: warning,
    disabled: disabled,
    fullWidth: fullWidth
  };

  var handleChange = function handleChange(onChange) {
    return function (event) {
      onChange({
        target: {
          value: event.target.value
        }
      });
    };
  };

  return _react.default.createElement(_styler.default, {
    classNames: classes,
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("div", _extends({
      className: styles,
      id: id,
      tabIndex: tabIndex
    }, (0, _getNativeProps.default)(props)), _react.default.Children.map(children, function (_ref2) {
      var props = _ref2.props;
      return _react.default.createElement(_option.Option, _extends({
        multiple: multiple,
        name: name,
        onChange: handleChange(onChange)
      }, props));
    }));
  });
};

var sizeProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('small', 'large');
var stateProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('error', 'warning');
SelectionGroup.propTypes = {
  /** {---} Sequence of: @@<SelectionGroupStateful.Option>@@ */
  children: _propTypes.any.isRequired,

  /** DEPRECATED: use fullWidth prop. */
  fluid: (0, _deprecatedProp.default)(_propTypes.bool, 'Deprecated: use fullWidth prop.'),
  fullWidth: _propTypes.bool,
  id: _propTypes.string,
  name: _propTypes.string,
  primary: _propTypes.bool,

  /** {bool} Mutually exclusive props: @@error@@ @@warning@@ */
  error: stateProps,

  /** {bool} Mutually exclusive props: @@error@@ @@warning@@ */
  warning: stateProps,
  disabled: _propTypes.bool,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  small: sizeProps,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  large: sizeProps,
  onChange: _propTypes.func.isRequired,
  tabIndex: _propTypes.string
};
SelectionGroup.defaultProps = {
  tabIndex: '-1'
};
SelectionGroup.Option = _option.Option;
_option.Option.displayName = 'SelectionGroup.Option';
var _default = SelectionGroup;
exports.default = _default;
SelectionGroup.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SelectionGroup",
  "props": {
    "fullWidth": {
      "defaultValue": {
        "value": "fluid",
        "computed": true
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "tabIndex": {
      "defaultValue": {
        "value": "'-1'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} Sequence of: @@<SelectionGroupStateful.Option>@@"
    },
    "fluid": {
      "type": {
        "name": "custom",
        "raw": "deprecated(bool, 'Deprecated: use fullWidth prop.')"
      },
      "required": false,
      "description": "DEPRECATED: use fullWidth prop."
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "primary": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "error": {
      "type": {
        "name": "custom",
        "raw": "stateProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@error@@ @@warning@@"
    },
    "warning": {
      "type": {
        "name": "custom",
        "raw": "stateProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@error@@ @@warning@@"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "small": {
      "type": {
        "name": "custom",
        "raw": "sizeProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "large": {
      "type": {
        "name": "custom",
        "raw": "sizeProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    }
  }
};